import { About, Hero } from "./elements";

export function Home() {
  return (
    <div className="Home">
      <Hero />
      <About />
    </div>
  );
}
